import script from "./yhqInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./yhqInfoList.vue?vue&type=script&setup=true&lang=js"

import "./yhqInfoList.vue?vue&type=style&index=0&id=49c5986e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c5986e"]])

export default __exports__